<template>
  <Modal
    v-model="status"
    :closable="false"
    :mask-closable="false"
    @on-ok="handleSubmit"
    title="修改内页"
  >
    <Form
      ref="formCustom"
      :model="formCustom"
      :rules="ruleCustom"
      label-position="top"
      style="max-width: 300px;width: auto;"
    >
      <!-- <FormItem label="登入内页编号" prop="SIid">
        <Input type="number" v-model="formCustom.SIid" size="default" disabled></Input>
      </FormItem> -->
      <FormItem label="导向网址" prop="InsideUrl">
        <Input type="text" v-model="formCustom.InsideUrl" size="default"></Input>
      </FormItem>
      <FormItem label="类别">
        <Select v-model="formCustom.class" size="default">
          <Option v-for="it in select" :key="it.key" :value="it.key">{{it.name}}</Option>
        </Select>
      </FormItem>
      <FormItem label="状态">
        <RadioGroup v-model="formCustom.status">
          <Radio class="mx-5 px-2" :label="1" border>啟用</Radio>
          <Radio class="mx-5 px-2" :label="0" border>停用</Radio>
        </RadioGroup>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: 'ModalEditInside',
  props: {
    data: {
      type: Object,
      default: () => {}
    },
  },
  data () {
    return {
      status: false,
      select: [
        { name: "未分类", key: 0 },
        { name: "总公司", key: 1 },
        { name: "代理", key: 2 },
        { name: "会员", key: 3 }
      ],
      formCustom: {
        SIid: '',
        InsideUrl: '',
        class: '',
        status: 1
      },
      ruleCustom: {
        // SIid: [
        //   { required: true, message: "请勿留空", trigger: 'blur' },
        //   { type: 'string', message: "格式错误", trigger: 'blur' },
        // ],
        InsideUrl: [
          { required: true, message: "请勿留空", trigger: 'blur' },
          { type: 'string', message: "格式错误", trigger: 'blur' },
        ]
      }
    }
  },
  watch: {
    data: {
      immediate: true,
      handler(newValue) {
        this.formCustom = newValue
      }
    }
  },
  computed: {
    ...mapGetters(['getmember'])
  },
  methods: {
    handleSubmit (){
      this.$refs['formCustom'].validate((valid) => {
        if (valid) {
          this.postInsideInfor()
        } else {
          this.$Message.success('请确认表格完整');
        }
      })
    },
    async postInsideInfor (id) {
      try {
        const obj = {
          SIid: this.formCustom.SIid,
          class: this.formCustom.class,
          InsideUrl: this.formCustom.InsideUrl,
          status: this.formCustom.status,
          loid: this.getmember.pid
        }
        const res = await this.$axios.websiteManagement.setlineInsideUpd(obj)
        if (res.status == 1) {
          this.$Message.success('修改成功');
          this.status = false;
          this.$emit('reloadInside');
        }
      } catch (error) {
        console.error(error);
      }
    },
    async open () {
      this.status = true;
    }
  }
}
</script>